import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import Typograph from "../../../components/Typograph"
import ThemeConsumer from "../ThemeConsumer"

const DefaultTitle = ({ children, theme, className }) => {
  const titleClass = classnames(theme.defaultTitle, className)

  return (
    <Typograph htmlTag="h1" size="extra_large" className={titleClass}>
      {children}
    </Typograph>
  )
}

DefaultTitle.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
  className: PropTypes.string
}

export default ThemeConsumer("UIDefaultTitle")(DefaultTitle)



// WEBPACK FOOTER //
// ./src/shared/components/DefaultTitle/index.js